<div class="loading-container">
    <div class="loader-container">
        <span class="loading-title">{{message}}</span>
        <p-progressSpinner styleClass="w-3rem h-3rem" ariaLabel="loading"></p-progressSpinner>
        <div class="loading-footer">
            Please Wait ...
        </div>
    </div>
</div>
